import { createContext } from 'react'
import type { StructureEntry } from '../types/structures'

export interface StructureContextValue {
  structures: StructureEntry[]
  selectedIds: number[] | null
  setSelectedIds: (ids: number[] | null) => void
  isLoading: boolean
}

export const StructureContext = createContext<StructureContextValue | null>(null)
